// Generated by Melange

import * as Buhta_components__LoadingDiv from "../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_core__Auth from "../../../packages/core/lib/Auth.js";
import * as Buhta_landing__DocsSite from "./pages/Docs/DocsSite.js";
import * as Buhta_landing__Route from "./Route.js";
import * as Buhta_landing__Site from "./pages/Landing/Site.js";
import * as JsxRuntime from "react/jsx-runtime";

function Home(Props) {
  const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const url = Buhta_landing__Route.useUrl(undefined);
  const route = Buhta_landing__Route.ofUrl(url);
  let tmp = match[0];
  if (/* tag */ (typeof tmp === "number" || typeof tmp === "string") && tmp === /* Loading */ 1) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}),
      className: "h-screen"
    });
  }
  if (/* tag */ typeof route === "number" || typeof route === "string") {
    return JsxRuntime.jsx(Buhta_landing__Site.make, {});
  } else if (route.TAG === /* Docs */ 1) {
    return JsxRuntime.jsx(Buhta_landing__DocsSite.make, {});
  } else {
    return JsxRuntime.jsx(Buhta_landing__Site.make, {});
  }
}

const make = Home;

export {
  make,
}
/* Buhta_components__LoadingDiv Not a pure module */
